import { Plus, Trash2, NotebookText, LogOut, FileText } from 'lucide-react';
import { cn } from '../lib/utils';
import { Button } from './ui/button';
import { ScrollArea } from './ui/scroll-area';
import { useAuth } from '../auth/AuthContext';

export default function Sidebar({ notes, activeId, onSelect, onCreate, onDelete }) {
  const { user, logout } = useAuth();

  return (
    <aside className="flex h-full w-64 shrink-0 flex-col border-r bg-background">
      <div className="flex items-center justify-between border-b px-4 py-3">
        <div className="flex items-center gap-2 font-semibold">
          <NotebookText className="h-5 w-5 text-primary" />
          <span>Mini Notion</span>
        </div>
        <Button size="icon" variant="ghost" onClick={onCreate} title="New note" aria-label="New note">
          <Plus className="h-5 w-5" />
        </Button>
      </div>

      <ScrollArea className="flex-1 p-2">
        {notes.length === 0 ? (
          <p className="px-3 py-6 text-center text-sm text-muted-foreground">No notes yet</p>
        ) : (
          <ul className="space-y-0.5">
            {notes.map((note) => (
              <NoteItem
                key={note.id}
                note={note}
                isActive={note.id === activeId}
                onSelect={() => onSelect(note.id)}
                onDelete={() => onDelete(note.id)}
              />
            ))}
          </ul>
        )}
      </ScrollArea>

      <div className="flex items-center justify-between gap-2 border-t px-4 py-3">
        <div className="min-w-0">
          <p className="truncate text-sm font-medium">{user?.name}</p>
          <p className="truncate text-xs text-muted-foreground">{user?.email}</p>
        </div>
        <Button variant="ghost" size="icon" onClick={logout} title="Log out" aria-label="Log out">
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </aside>
  );
}

function NoteItem({ note, isActive, onSelect, onDelete }) {
  return (
    <li>
      <div
        className={cn(
          'group flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm',
          isActive ? 'bg-accent text-accent-foreground' : 'hover:bg-accent/50'
        )}
      >
        <button
          type="button"
          onClick={onSelect}
          className="flex min-w-0 flex-1 items-center gap-2 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded"
        >
          <FileText className="h-4 w-4 shrink-0 text-muted-foreground" />
          <span className="truncate">{note.title || 'Untitled note'}</span>
        </button>
        <button
          type="button"
          onClick={onDelete}
          title="Delete note"
          aria-label="Delete note"
          className="hidden shrink-0 rounded p-0.5 text-muted-foreground hover:text-destructive group-hover:inline-flex"
        >
          <Trash2 className="h-3.5 w-3.5" />
        </button>
      </div>
    </li>
  );
}
